import React, {useState, useCallback, useEffect, useRef} from 'react'
import Input from './Input'
import _debounce from 'lodash/debounce';
import axiosService from '../../utils/AxiosService';
import { toastError } from './Toasts'
import { useReadOnly } from '../../contexts/ReadOnlyContext'

const UpdatableField = ({ url, model, attribute, className, children, manipulateValue = (value) => value, onFieldUpdate = () => {}}) => {
  const readOnly = useReadOnly()
  const [isUpdating, setIsUpdating] = useState(false)
  const [currentValue, setCurrentValue] = useState(children)
  const originalValue = useRef(children)

  const updateValue = (newValue) => {
    const manipulatedValue = manipulateValue(newValue)
    
    // Handle nested attributes (e.g., 'audience_information.fake_follower_rate')
    const attributeParts = attribute.split('.')
    let updateData = { [model]: {} }
    
    if (attributeParts.length === 1) {
      // Simple attribute
      updateData[model][attribute] = manipulatedValue
    } else {
      // Nested attribute
      let current = updateData[model]
      for (let i = 0; i < attributeParts.length - 1; i++) {
        const part = attributeParts[i]
        current[`${part}_attributes`] = current[`${part}_attributes`] || {}
        current = current[`${part}_attributes`]
      }
      current[attributeParts[attributeParts.length - 1]] = manipulatedValue
    }
    axiosService.patch(url, updateData)
      .then((resp) => {
        onFieldUpdate(resp)
        setIsUpdating(false)
      })
      .catch((error) => {
        const errorMessage = error?.data?.error || 
                           error?.error || 
                           error?.message || 
                           'An error occurred while updating the field'
        toastError(errorMessage)
        setCurrentValue(originalValue.current)  // Pass the original value to help with reverting
        setIsUpdating(false)
      })
  }

  const classNameWithoutTextColor = (className || '').replace(/text-\S+/g, '').trim();


  const debounce = useCallback(_debounce(updateValue, 1000), [url]);

  useEffect(() => {
    setCurrentValue(children)
  }, [children])

  return (
    <div
      className={readOnly ? '' : 'hover:cursor-pointer'}
      onDoubleClick={() => {
        if (readOnly) return
        setCurrentValue(children)
        originalValue.current = children
        setIsUpdating(true)
      }}
    >
      {
        isUpdating ? (
          <Input
            topMargin='mt-0'
            noGreenBorder
            overrideClassName={`${classNameWithoutTextColor} text-rb-black`}
            value={currentValue}
            onChange={(e) => {
              setCurrentValue(e.target.value)
              debounce(e.target.value)
            }}
            onBlur={() => setIsUpdating(false) }
          />
        ) : (
          <span className={className}>{currentValue}</span>
        )
      }
    </div>
   );
}

export default UpdatableField;
